module.exports = __webpack_public_path__ + "static/media/061.905914d3.jpg";